import type { Theme } from '@mui/material/styles'

const MuiMenu = (baseTheme: Theme) => ({
  defaultProps: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
  },
  styleOverrides: {
    paper: {
      '&.MuiPaper-root': {
        borderRadius: baseTheme.spacing(0.8),
        backgroundColor: baseTheme.palette.neutral.white,
        boxShadow: baseTheme.shadows[4],
        marginTop: -5,
      },
    },
    list: {
      padding: 0,
      minWidth: baseTheme.spacing(12),
    },
  },
})

export default MuiMenu
